import { AppConfig } from './../../app/app.config';
import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { TeamManagerService } from './../../services/teammanager.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
/*
    修改返点
    TQQ 2017-01-05
*/
@Component({
    selector: "change-bonus",
    templateUrl: "changebonus.html",
    providers: [
        TeamManagerService,
        AlertService
    ]
})
export class ChangeBonus {
    constructor(
        private viewCtrl: ViewController,
        private teammanager: TeamManagerService,
        private alert: AlertService,
        private loadding: LoaddingService,
        private navpar: NavParams,
        private storage: StorageService,
        private config: AppConfig
    ) { }
    AppConfig = AppConfig;
    userInformation = this.AppConfig.User;
    userBounsInfo = new information;
    lotteryReturn: number;
    returns = [];
    sysconfig = this.config.getSysConfig();
    ionViewDidLoad() {
        this.userBounsInfo = this.navpar.data.information;      //需要设置的用户的返点信息
        //bouns 最低返点
        let bonus =  this.userBounsInfo.Bonus;           //返点只能调高 不能调低 所以当前设置的用户返点就是可调节范围内最小返点
        let reward;
        if (this.userBounsInfo.Bonus >= 7.9) {
            reward = (bonus / this.sysconfig.BonusGruduation * this.sysconfig.PerGraduation + this.sysconfig.BasicReward).toFixed(0) + '-' + bonus.toFixed(1);
            var item = { bonus: bonus.toFixed(1), reward: reward };
            this.returns.splice(0, 0, item);
            bonus = parseFloat((bonus).toFixed(1));
        } else {
            while (bonus <= this.userInformation.Bonus && bonus >= this.sysconfig.ClientMinBonus) {//(bonus >= this.sysconfig.ClientMinBonus) {
                reward = (bonus / this.sysconfig.BonusGruduation * this.sysconfig.PerGraduation + this.sysconfig.BasicReward).toFixed(0) + '-' + bonus.toFixed(1);
                var item = { bonus: bonus.toFixed(1), reward: reward };
                this.returns.splice(0, 0, item);
                bonus = parseFloat((bonus + this.sysconfig.ClientGraduation).toFixed(1));
            }
        }
        if (this.returns && this.returns.length > 0) {
            this.lotteryReturn = this.returns[0].bonus;
        }
    }
    //确定改变返点
    //chen 2017-01-09
    change() {
        if (!this.lotteryReturn) {
            this.alert.showAlert('该用户不能调整返点');
            return;
        }
        this.teammanager.updateChangeBonus(this.userBounsInfo.UserName, this.lotteryReturn.toString()).then(s => {
            this.alert.showAlert(s.Error);
            if (s.Result) {
                this.viewCtrl.dismiss(s);
            }
        });
    }

    //关闭
    //chen 2017-01-03
    dismiss() {
        this.viewCtrl.dismiss();
    }
}

export class information {
    //返点
    Bonus: number;
    //用户名
    UserName: string;
    //用户类型
    UserTypeName: string;
    //用户余额
    UserMoney: Number
}









// WEBPACK FOOTER //
// ./src/pages/teammanager/changebonus.ts